import React, { FC, useCallback, useEffect, useId, useRef } from "react";
import { appSignals } from "@cayo/shared/components/App/utils";
import { FormProps } from "@cayo/shared/components/Form/types";
import { useForceUpdate } from "@cayo/shared/hooks/useForceUpdate";
import useService from "@cayo/shared/services/hooks/useService";
import { ajaxUtils } from "@cayo/shared/utils/ajax";
import CollectActionParametersDialog from "../Dialogs/CollectActionParametersDialog";

export const FormsHolder: FC = () => {
  const formProps = useRef<Array<FormProps>>([]);
  const { forceUpdate } = useForceUpdate();
  const actionBuilder = useService("actionBuilder");

  const baseFromId = useId();

  useEffect(() => {
    return appSignals.subscribe("showForm", (data) => {
      if (data?.form) {
        formProps.current.push({ ...data.form, actionBuilder });
        forceUpdate();
      }
    });
  }, []);

  // useEffect(() => {
  //   appSignals.send("showForm", { form: { ...resultDialogScheme, actionBuilder } });
  // }, []);

  const removeFormCb = useCallback((p: FormProps) => {
    const index = formProps.current.indexOf(p);
    formProps.current.splice(index, 1);
    forceUpdate();
  }, []);

  return (
    <>
      {formProps?.current?.map((p, i) => (
        <CollectActionParametersDialog
          key={baseFromId + i}
          {...p}
          onClose={(result) => {
            removeFormCb(p);
            //if (result !== undefined) {
            p.onClose && p.onClose(result ?? false);
            //}
          }}
          onSubmit={
            p.onSubmit
              ? async (result) => {
                  try {
                    const r = await p.onSubmit!(result);
                    removeFormCb(p);
                    return r;
                  } catch (e) {
                    await ajaxUtils.handleError(e);
                  }
                }
              : null
          }
          actionBuilder={actionBuilder}
        />
      ))}
    </>
  );
};
